import Vue from 'vue';

// Containers
import Offer from '@/containers/Offer.vue';
import Maintenance from '@/views/Maintenance.vue';
import routerData from './routerData';

Vue.use(routerData.Router);

const children = [
    ...routerData.homepage,
    ...routerData.base,
    ...routerData.sport,
    ...routerData.outrights,
    ...routerData.lotto,
    ...routerData.horses,
    {
        path: '',
        redirect: '/web/sport',
    },
];

const RouterOut = new routerData.Router(
    {
        mode: 'history',
        linkActiveClass: 'is-selected',
        routes: [
            {
                name: 'maintenance',
                path: '/:lang?/web/maintenance',
                component: Maintenance,
                meta:
                {
                    title: 'WEBSITEMAINTENANCE',
                },
            },
            {
                path: '/:lang?/web/',
                component: Offer,
                props: true,
                meta:
                {
                    title: 'WEBSITEDEFAULT',
                },
                children,
            },
            {
                path: '*',
                name: 'REDIRECT',
                redirect: '/hr-HR/web/sport',
            },
        ],
    },
);

function hasQueryParams(route)
{
    return !!Object.keys(route.query).length;
}

RouterOut.beforeEach((to, from, next) =>
{
    if (!hasQueryParams(to) && hasQueryParams(from))
    {
        next({
            ...to,
            query: from.query,
        });
    }
    else
    {
        next();
    }
});

RouterOut.afterEach((to) =>
{
    window.emit('pageUrlChanged', to.path);
});

export default RouterOut;
